import type { SVGProps } from 'react';

export const VisaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path fill="#E6E6E6" d="M24 6.652H0v9.913h24V6.652Z" />
    <path
      fill="#E79800"
      fillRule="evenodd"
      d="M1.565 20.74h20.87c.864 0 1.565-.702 1.565-1.566v-2.609H0v2.609c0 .864.7 1.565 1.565 1.565Z"
      clipRule="evenodd"
    />
    <path
      fill="#1A1876"
      fillRule="evenodd"
      d="M22.435 3H1.565C.701 3 0 3.7 0 4.565v2.609h24V4.565C24 3.701 23.3 3 22.435 3ZM9.516 14.374h1.36l.853-4.996h-1.362l-.851 4.996ZM14.474 11.384c-.476-.231-.767-.386-.764-.62 0-.207.247-.43.78-.43.436-.006.788.082 1.142.25l.184-1.084a3.515 3.515 0 0 0-1.22-.21c-1.346 0-2.294.678-2.302 1.65-.007.717.677 1.118 1.194 1.357.53.245.708.401.706.62-.004.335-.424.488-.815.488-.604 0-.91-.094-1.458-.342l-.19 1.118c.318.14.906.26 1.517.267 1.431 0 2.36-.67 2.371-1.707.004-.568-.359-1-1.145-1.357Z"
      clipRule="evenodd"
    />
    <path
      fill="#1A1876"
      d="M19.308 9.382h-1.052c-.326 0-.57.09-.713.415l-2.022 4.579h1.43s.233-.616.287-.751l1.744.002c.04.175.166.748.166.748h1.263l-1.103-4.993Zm-1.679 3.221c.057-.144.612-1.57.723-1.873.185.861.005.025.408 1.873h-1.13Z"
    />
    <path
      fill="#1A1876"
      fillRule="evenodd"
      d="M8.374 9.381 7.04 12.788l-.142-.692L6.421 9.8c-.083-.316-.322-.41-.617-.422H3.607l-.017.104a5.74 5.74 0 0 1 1.43.548l1.211 4.34 1.441-.002L9.816 9.38H8.374Z"
      clipRule="evenodd"
    />
  </svg>
);
